import {ref, reactive, toRefs, computed,watch,defineComponent,onBeforeMount,onMounted,getCurrentInstance,provide,nextTick} from 'vue';
import CxCardUtil,{ICxCardDataObj} from './cxCardUtil';
export default defineComponent({
    name:'CxCard',
    title:'车型管理',
    modelType:'card',
    fullscreen: false,
    setup(){
        let {proxy}=getCurrentInstance() as any;
        const utils=proxy.utils;
        provide('uploadOwner', proxy);
        let dataObj:ICxCardDataObj=reactive<ICxCardDataObj>({
            utilInst:{} as any,
            formRef:null,
            disabled:false,
            refMap:new Map(),
            //卡片传给dialog的初始化参数
            compParams: {
                hsDetails: false,
                modelPath: utils.ToolsProviderApi.buildUrl('/cx')
            },
            //表单
            form:{},
            //表单验证规则
            rules: {
                brand: [utils.UtilPub.commonValidRule('请选择品牌')],
                name: [utils.UtilPub.commonValidRule('请输入车型名称')]
            },
            otherParams:{
                toolBrandData:[]
            }
        })
        onBeforeMount(()=>{
            dataObj.utilInst=new CxCardUtil(proxy,dataObj);
        })
        onMounted(()=>{
            nextTick(async()=>{
                await dataObj.utilInst.buildSelectData();
            })
        })
        //---------------------------computed---------------------------
        //下拉select数据集获取（数据集构造和cascader类似）
        const comboSelect=computed(()=>{
            return (params:any) => {
                if(params && 'brandId'==params.comboId){
                    // return [{value:1,label:'金杯'},{value:2,label:'斯威'},{value:3,label:'新能源'}]
                    return dataObj.otherParams.toolBrandData;
                }
                if(params && 'sysczs'==params.comboId){
                    return [{value:0,label:'展示'},{value:1,label:'不展示'}]
                }
                if(params && 'wxsczs'==params.comboId){
                    return [{value:0,label:'展示'},{value:1,label:'不展示'}]
                }
            }
        })
        const buildUploadInitParams=computed(()=>{
            return (params:any) => {
                return Object.assign({
                    belongMaxId:dataObj.form.id,
                    fileSize:10,
                    saveType:1,
                    limitNum:1,
                    listType:'picture-card',
                    accept:'.jpg,.JPG,.png,.PNG,.jpeg,.JPEG',
                    showFileList:true
                },params)
            }
        })
        //---------------------------selectOnchange--------------------------
        const selectOnChange=(newValue:string,selectId:string)=>{
            if('brand'==selectId){}
        }
        //打开弹出框的回调事件(已请求完/add或/edit，data是返回值)
        const beforeOpen=async(res:any,addOrLoad:string,engineInst:any)=>{

        }
        //保存之前，校验整个保存数据是否合法
        const beforeSaveHandler=()=>{
            return true;
        }

        return{
            ...toRefs(dataObj),comboSelect,selectOnChange,beforeOpen,beforeSaveHandler,
            buildUploadInitParams
        }
    }
});